<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
            class="btn btn_action btn_add"
            title="Přidat skupinu stanic"
            @click.prevent="createItem"
          >Přidat skupinu stanic</a>
        </p>
        <h1 v-translate>Skupiny stanic</h1>
      </div>

      <app-table
          :data="items"
          :highlight-rows-on-hover="true"
          clickable
          deletable
          :order="params.order"
          :page-size="params.limit"
          @sort="sortItems"
          @rowClick="goToDetail"
          @deleteRow="deleteItem"
          :loading="pending"
      >
        <app-table-column first sortable attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              {{ row.name }}
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="deviceVisibility" :label="translations.deviceVisibility">
            <template slot-scope="row">
                <app-graphic-image
                    :value="row.deviceVisibility"
                />
            </template>
        </app-table-column>
        <app-table-column sortable attribute="numberOfTvStations" :label="translations.numberOfTvStations" />
        <app-table-column sortable attribute="order" :label="translations.order" />
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata && itemsMetadata.totalCount > params.limit">
          <app-table-pagination
            :page="listPage"
            :itemsPerPage="params.limit"
            :totalCount="itemsMetadata.totalCount"
            @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'TvStationGroups',
  enumsMap: true
})

export default {
  name: 'station-groups',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  methods: {
    getDeleteError(item) {
      if (item.numberOfTvStations !== 0) {
        return this.$gettext('Skupinu nelze smazat, protože obsahuje stanice.')
      }
      return null
    },
    shouldConfirmDelete() {
      return false
    }
  },
  computed: {
    translations() {
      return {
        deviceVisibility: 'Viditelné na zařízení',
        name: this.$gettext('Název'),
        numberOfTvStations: this.$gettext('Počet TV stanic'),
        order: this.$gettext('Pořadí'),
        created: this.$gettext('Založeno')
      }
    },
    currentTitle() {
      return [
        this.$gettext('Skupiny stanic')
      ]
    }
  }
}
</script>
